import { Component, OnInit, HostListener } from "@angular/core";
import { GlobalService } from "../global-service";
import { Router, ActivatedRoute } from "@angular/router";
let $: any;

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  visibleSidebar: boolean;
  displayInfo: boolean = false;
  blogsList: any = [];
  selectedBlogs: any;
  menuOpen: boolean = false;

  logos: any;

  news: any;
  banners: any = [];
  LogoData: any = [];

  HtmlData: any;
  DocId: any;
  mainData: any;

  constructor(
    public global: GlobalService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.blogsList = [
      { label: "Travel", value: 1 },
      { label: "Health", value: 2 },
      { label: "Finance", value: 3 },
      { label: "Food", value: 4 },
      { label: "Music", value: 5 },
    ];

    this.logos = [
      {
        name: "assets/logos/FitIndia.jfif",
      },
      {
        name: "assets/logos/IOA.jfif",
      },
      {
        name: "assets/logos/kheloindialogo.webp",
      },
      {
        name: "assets/logos/Ministry-of-Youth-Affairs-and-Sports.jpg",
      },

      {
        name: "assets/logos/NADA.jpg",
      },

      {
        name: "assets/logos/SAI.jfif",
      },
      {
        name: "assets/logos/WorldArcheryAsia.jpg",
      },
      {
        name: "assets/logos/WorldArchery.jpg",
      },
      {
        name: "assets/logos/WorldArchery2.png",
      },
    ];
  }

  ngOnInit() {
    this.getNews();
    this.getBannerList();
    this.getResults();
    this.getDetails();
  }

  getDetails() {
    const url = this.global.basePath + "common/circularlist?modelType=footer";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.mainData = res[0].json.circular;

      this.HtmlData = data[0].html;
      this.DocId = res[0].json.circular[0]._id;

      setTimeout(() => {
        const table = document.getElementsByTagName("table");
        for (var i = 0; i < table.length; i++) {
          table[i].style.width = "100%";
          table[i].style.border = "1px solid #dbdbdb";
        }
        const td = document.getElementsByTagName("td");

        for (var i = 0; i < td.length; i++) {
          td[i].style.border = "1px solid #dbdbdb";
          td[i].style.padding = "10px";
        }
      }, 500);
    });
  }

  getResults() {
    const url = this.global.basePath + "common/circularlist?modelType=logo";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.LogoData = data;
    });
  }

  openT() {
    this.menuOpen = true;
  }
  closeT() {
    this.menuOpen = false;
  }

  profileModel() {
    this.displayInfo = true;
  }

  login() {
    this.router.navigateByUrl("/login");
  }
  register() {
    this.router.navigateByUrl("/role-select");
  }
  profile() {
    this.router.navigateByUrl("home/profile/info");
  }
  toHome() {
    this.router.navigateByUrl("/");
    window.scroll(0, 0);
  }

  getNews() {
    const url = this.global.basePath + "news";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      console.log(
        "🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res",
        res
      );
      const data = res[0].json.data;
      this.news = data;
    });
  }
  getBannerList() {
    const url = this.global.basePath + "news/banner";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.banners = data;
    });
  }
}
